import React, { useMemo } from "react";
import "./Divider.less";

interface DividerProps {
   children?: React.ReactNode;
   className?: string;
   dashed?: boolean;
   orientation?: "left" | "right" | "center";
   orientationMargin?: number;
   plain?: boolean;
   style?: React.CSSProperties;
   type?: "horizontal" | "vertical";
}

export const Divider: React.FC<DividerProps> = ({
   children,
   className = "",
   dashed = false,
   orientation = "center",
   orientationMargin,
   plain,
   style,
   type = "horizontal"
}) => {
   const marginStyles =
      orientation === "left" && orientationMargin && children
         ? {
              marginLeft: `${orientationMargin}px`
           }
         : {
              marginRight: `${orientationMargin}px`
           };

   const classNames = useMemo(() => {
      let finalClassName = "bp2-divider";
      
      if (type === "horizontal") {
         finalClassName += " bp2-divider--horizontal";
      } else {
         finalClassName += " bp2-divider--vertical";
      }

      if (dashed) {
         finalClassName += " bp2-divider--dashed";
      }

      if (dashed && type === "vertical") {
         finalClassName += " bp2-divider-vertical--dashed";
      }

      if (children && type !== "vertical") {
         finalClassName += " bp2-divider--with-text";
      }

      if (children && dashed) {
         finalClassName += " bp2-divider--with-text-dashed";
      }

      if (children && plain) {
         finalClassName += " bp2-divider--plain";
      }

      if (children && orientation !== "center") {
         finalClassName += ` bp2-divider--with-text-${orientation}`;
      }

      if (children && orientation !== "center" && orientationMargin) {
         finalClassName += ` bp2-divider-orientation-margin-${orientation}`;
      }

      if (children && orientation !== "center" && orientationMargin === 0) {
         finalClassName += ` bp2-divider-orientation-margin-${orientation}-no-margin`;
      }

      if (className) finalClassName += ` ${className}`;

      return finalClassName;
   }, [children, type, orientation, orientationMargin, dashed, plain, className]);

   return (
      <div className={classNames} style={style}>
         {children && type !== "vertical" && (
            <span style={marginStyles} className="bp2-divider__text">
               {children}
            </span>
         )}
      </div>
   );
};

export default Divider;
